import React, { useState } from "react";

const Interest = ({
  rate,
  values,
  errors,
  edit,
  touched,
  handleBlur,
  handleChange,
}) => {
  return (
    <div>
      <div className='position-relative'>
        <h5 className='text-primary-1 mt-2'>RATE</h5>
        <div className='row'>
          <div className='col-md-3 mb-2'>
            <label
              htmlFor='policy_name'
              className={`form-label ${edit ? "" : "fw-bolder"}`}
            >
              Default Rate{" "}
              {edit ? <span className='text-danger'>*</span> : null}
            </label>
            {!edit ? <p>{rate?.default_rate}</p> : null}
            {edit ? (
              <>
                <input
                  type='text'
                  className={`form-control ${
                    (errors?.default_interest_rate || errors?.default_rate) &&
                    touched?.default_interest_rate &&
                    "is-invalid"
                  }`}
                  name='default_interest_rate'
                  id='default_interest_rate'
                  defaultValue={values?.default_interest_rate}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder='0.00'
                />
                {(errors?.default_interest_rate || errors?.default_rate) &&
                  touched?.default_interest_rate && (
                    <span className='text-danger'>
                      {errors?.default_interest_rate || errors?.default_rate}
                    </span>
                  )}
              </>
            ) : null}
          </div>
          <div className='col-md-3 mb-2'>
            <label
              htmlFor='policy_name'
              className={`form-label ${edit ? "" : "fw-bolder"}`}
            >
              Minimum Rate
              {edit ? <span className='text-danger'>*</span> : null}
            </label>
            {!edit ? <p>{rate?.default_rate}</p> : null}
            {edit ? (
              <>
                <input
                  type='text'
                  className={`form-control ${
                    (errors?.minimum_interest_rate || errors?.min_rate) &&
                    touched?.minimum_interest_rate &&
                    "is-invalid"
                  }`}
                  name='minimum_interest_rate'
                  id='minimum_interest_rate'
                  value={values?.minimum_interest_rate}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder='0.00'
                />
                {(errors?.minimum_interest_rate || errors?.min_rate) &&
                  touched?.minimum_interest_rate && (
                    <span className='text-danger'>
                      {errors?.minimum_interest_rate || errors?.min_rate}
                    </span>
                  )}
              </>
            ) : null}
          </div>
          <div className='col-md-3 mb-2'>
            <label
              htmlFor='policy_name'
              className={`form-label ${edit ? "" : "fw-bolder"}`}
            >
              Maximum Rate{" "}
              {edit ? <span className='text-danger'>*</span> : null}
            </label>
            {!edit ? <p>{rate?.maximum_rate}</p> : null}
            {edit ? (
              <>
                <input
                  type='text'
                  className={`form-control ${
                    errors?.maximum_interest_rate &&
                    touched?.maximum_interest_rate &&
                    "is-invalid"
                  }`}
                  name='maximum_interest_rate'
                  id='maximum_interest_rate'
                  value={values?.maximum_interest_rate}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder='0.00'
                />
                {errors?.maximum_interest_rate &&
                  touched?.maximum_interest_rate && (
                    <span className='text-danger'>
                      {errors?.maximum_interest_rate}
                    </span>
                  )}
              </>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Interest;
